import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

//Product Enquiry - Get All (Read)
export const GetAll = createAsyncThunk(
  "product_enquirys/product_enquiry/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Product_Enquirys.Product_Enquiry}?name=${filter?.name || ""}
        &product_id=${filter?.product_id || ""}&contact_no=${filter?.contact_no || ""}
        &email=${filter?.email || ""}&subject=${filter?.subject || ""}
        &message=${filter?.message || ""}&page=${filter?.page || IDS.PAGE}
        &per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//- Get (Read)
export const GetSingle = createAsyncThunk(
  "product_enquirys/product_enquiry/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Product_Enquirys.Product_Enquiry}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// - Create (Add)
export const Create = createAsyncThunk(
  "product_enquirys/product_enquiry/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Product_Enquirys.Product_Enquiry, data);
      return res; // The new object
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Update
export const Update = createAsyncThunk(
  "product_enquirys/product_enquiry/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(
        `${APIS.Product_Enquirys.Product_Enquiry}/${id}`,
        data,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Delete
export const Delete = createAsyncThunk(
  "product_enquirys/product_enquiry/delete",
  async (id, { rejectWithValue }) => {
    try {
      const data = await DELETE(
        `${APIS.Product_Enquirys.Product_Enquiry}/${id}`,
      );
      return id; // Return the id of the deleted bill
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Status
export const StatusProductEnquiry = createAsyncThunk(
  "product_enquirys/product_enquiry/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Product_Enquirys.Product_Enquiry}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "productenquiry",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (productenquiry) => productenquiry.id !== action.payload,
        ); // Remove with the deleted id
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //
      .addCase(StatusProductEnquiry.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusProductEnquiry.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.map((item) =>
          item.id === action.payload.id
            ? { ...item, status: !item.status }
            : item,
        ); // Remove the with the deleted id
      })
      .addCase(StatusProductEnquiry.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
